import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const PublicLayout = () => {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "dark");
    localStorage.setItem("theme", "dark");
  }, [theme]);

  const toggleTheme = () => setTheme("dark");

  return (
    <>
      <Header theme={theme} toggleTheme={toggleTheme} />
      <main
        className="flex-grow min-h-screen"
        style={{ backgroundColor: "var(--bg-primary)" }}
      >
        <Outlet context={{ theme }} />
      </main>
      <Footer />
    </>
  );
};

export default PublicLayout;
